import { render, staticRenderFns } from "./HomeBlock.vue?vue&type=template&id=66b348c7&scoped=true&"
import script from "./HomeBlock.vue?vue&type=script&lang=js&"
export * from "./HomeBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomeBlock.vue?vue&type=style&index=0&id=66b348c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b348c7",
  null
  
)

export default component.exports